import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCaseUpper';
/** Renders an SVG icon. */
const SvgCaseUpper = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M26.765 25q-.226 0-.277-.231l-.753-2.983q-.026-.078-.126-.077h-5.55q-.126 0-.126.077l-.728 2.983q-.025.231-.276.231h-1.96a.27.27 0 0 1-.2-.077q-.05-.078-.025-.206L21.39 7.231Q21.44 7 21.666 7h2.361q.226 0 .276.231l4.672 17.486.025.077q0 .206-.251.206zm-6.304-5.349q-.026.026 0 .078a.2.2 0 0 0 .1.025h4.546q.051 0 .075-.025.05-.052.026-.078l-2.336-9.308q-.026-.052-.05-.052-.026 0-.05.052L20.46 19.65ZM13.03 25q-.226 0-.277-.231L12 21.786q-.026-.078-.126-.077h-5.55q-.126 0-.126.077l-.728 2.983Q5.444 25 5.193 25H3.234a.27.27 0 0 1-.2-.077q-.05-.078-.026-.206L7.655 7.231Q7.705 7 7.93 7h2.36q.228 0 .277.231l4.672 17.486.025.077q0 .206-.251.206zm-6.304-5.349q-.026.026 0 .078a.2.2 0 0 0 .1.025h4.546q.05 0 .075-.025.05-.052.025-.078l-2.335-9.308q-.026-.052-.05-.052-.026 0-.05.052L6.724 19.65Z"
      />
    </svg>
  );
};
SvgCaseUpper.displayName = displayName;
export default SvgCaseUpper;
